import { createBrowserRouter, Navigate } from "react-router-dom";
import { Root } from "./Root";
import App from "./App";
import { Directory } from "apps/directory/Directory";
import { Operator } from "apps/directory/Operator";
import { Home, OperatorHome } from "apps/home";
import { CustomLists } from "apps/customLists/CustomLists";
import { CustomListDetails } from "apps/customLists/CustomListDetails";
// import { Campaigns } from "apps/campaigns/Campaigns";
import { Widgets } from "apps/widgets/Widgets";
import { i18nNamespace, loadLanguagePacks } from "i18n";
import { OrganizationProfile } from "apps/directory/OrganizationProfile";
import { WidgetDetails } from "apps/widgets/WidgetDetails";
import { Error404 } from "Error404";
import { Onboarding, PostOnboarding } from "onboarding";
import { Events } from "apps/events/Events";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Onboarding />,
    loader: async () =>
      loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Onboarding]),
  },
  {
    path: "/app",
    errorElement: <Error404 />,
    element: <Root />,
    loader: async () => loadLanguagePacks([i18nNamespace.Core]),
    children: [
      {
        path: "",
        element: <App />,
        loader: async () => loadLanguagePacks([i18nNamespace.Core]),
      },
      {
        path: "welcome",
        element: <PostOnboarding />,
        loader: async () =>
          loadLanguagePacks([i18nNamespace.Core, i18nNamespace.PostOnboarding]),
      },
      {
        path: "organization/:organizationId",
        children: [
          {
            path: "home",
            element: <Home />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Home]),
          },
          {
            path: "directory",
            element: <Directory />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Directory]),
          },
          {
            path: "directory/:operatorEntityId",
            element: <Operator />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Directory]),
          },
          {
            path: "profile",
            element: <OrganizationProfile />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Directory]),
          },
          {
            path: "custom-lists",
            element: <CustomLists />,
            loader: async () =>
              loadLanguagePacks([
                i18nNamespace.Core,
                i18nNamespace.CustomLists,
              ]),
          },
          {
            path: "custom-lists/:listId",
            element: <CustomListDetails />,
            loader: async () =>
              loadLanguagePacks([
                i18nNamespace.Core,
                i18nNamespace.CustomLists,
              ]),
          },
          /*
          {
            path: "campaigns",
            element: <Campaigns />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Campaigns]),
          },
          */
          {
            path: "widgets",
            element: <Widgets />,
            loader: async () =>
              loadLanguagePacks([
                i18nNamespace.Core,
                i18nNamespace.Widgets,
                i18nNamespace.Events,
              ]),
          },
          {
            path: "widgets/:widgetId",
            element: <WidgetDetails />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Widgets]),
          },
          {
            path: "events",
            element: <Events />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Events]),
          },
          // {
          //   path: "settings",
          //   element: <Settings />,
          //   loader: async () =>
          //     loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Settings]),
          // },
          {
            path: "",
            element: <Navigate to="home" replace={true} />,
          },
        ],
      },
      {
        path: "operator",
        children: [
          {
            path: "",
            element: <OperatorHome />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Directory]),
          },
          {
            path: ":operatorEntityId",
            element: <Operator />,
            loader: async () =>
              loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Directory]),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace={true} />,
  },
]);
